<template>
  <div class="renderPage animate-fade-in reporte-container">
    <!-- Header Section -->
    <v-toolbar color="primary" dark flat class="mb-4 rounded-xl">
        <v-icon class="mr-2" size="24">mdi-chart-bar</v-icon>
        <v-toolbar-title class="text-subtitle-1 text-sm-h5 font-weight-black px-0 text-uppercase">
            REPORTE VENTAS
        </v-toolbar-title>
        <v-spacer></v-spacer>
        <v-btn icon color="white" to="/home" class="glass-btn">
            <v-icon>mdi-close</v-icon>
        </v-btn>
    </v-toolbar>

    <v-container fluid class="pa-0">
      <v-row>
        <!-- Filters Area -->
        <v-col cols="12" class="mb-2">
            <v-card class="glass-card rounded-xl pa-4 elevation-2">
                <v-form ref="form" v-model="valid">
                    <v-row align="center">
                        <!-- Periodo -->
                        <v-col cols="12" sm="5" md="4" class="py-1">
                            <v-dialog ref="dialog" v-model="dateModal" :return-value.sync="dates" persistent width="290px">
                                <template v-slot:activator="{ on, attrs }">
                                    <v-text-field v-model="dates" label="Periodo" prepend-inner-icon="mdi-calendar" readonly required
                                        :rules="dateRules" v-bind="attrs" v-on="on" outlined dense rounded hide-details></v-text-field>
                                </template>
                                <v-date-picker v-model="dates" range color="primary">
                                    <v-spacer></v-spacer>
                                    <v-btn text color="primary" @click="dateModal = false">Cancel</v-btn>
                                    <v-btn text color="primary" @click="$refs.dialog.save(dates)">OK</v-btn>
                                </v-date-picker>
                            </v-dialog>
                        </v-col>

                        <!-- Usuarios -->
                        <v-col cols="12" sm="4" md="4" class="py-1">
                            <v-select label="Usuarios" item-text="nombre" item-value="cedula" v-model="reporte.cedula" :items="usuarios"
                                :disabled="!validUsuarios" outlined dense rounded hide-details prepend-inner-icon="mdi-account"></v-select>
                        </v-col>

                        <!-- Generar Botón -->
                        <v-col cols="12" sm="3" md="4" class="py-1 d-flex align-center">
                            <v-btn color="primary" class="rounded-pill font-weight-bold" elevation="2" @click="getReport()" :disabled="!valid" height="40" block>
                                <v-icon left>mdi-file-document-outline</v-icon>
                                Generar
                            </v-btn>
                        </v-col>
                    </v-row>
                </v-form>
            </v-card>
        </v-col>

        <!-- Tabs and Table Area -->
        <v-col cols="12">
            <v-card class="rounded-xl overflow-hidden glass-card elevation-2">
                <v-tabs background-color="transparent" color="primary" fixed-tabs v-model="tab2" height="48" class="border-bottom">
                    <v-tabs-slider color="primary"></v-tabs-slider>
                    <v-tab key="sorteos" class="font-weight-bold">
                        <v-icon left small>mdi-ticket-percent</v-icon>
                        <span class="d-none d-sm-flex">Sorteos</span>
                        <span class="d-flex d-sm-none">Sorteos</span>
                    </v-tab>
                    <v-tab key="detalles" class="font-weight-bold">
                        <v-icon left small>mdi-format-list-bulleted</v-icon>
                        <span class="d-none d-sm-flex">Detalles</span>
                        <span class="d-flex d-sm-none">Detalles</span>
                    </v-tab>
                </v-tabs>

                <v-tabs-items v-model="tab2" style="background: transparent;">
                    <!-- Sorteos Tab -->
                    <v-tab-item key="sorteos">
                        <v-data-table 
                            :headers="headers" 
                            :items="items" 
                            class="premium-table"
                            mobile-breakpoint="0"
                        >
                            <template v-slot:[`item.comision`]="{ item }">
                                <span class="font-weight-medium">₡{{ item.comision }}</span>
                            </template>
                            
                            <template v-slot:[`item.monto`]="{ item }">
                                <span class="success--text font-weight-black">₡{{ item.monto }}</span>
                            </template>

                            <template v-slot:[`item.actions`]="{ item }">
                                <v-btn color="primary" icon small class="elevation-1" @click.stop="editItem(item)">
                                    <v-icon small>mdi-eye</v-icon>
                                </v-btn>
                            </template>
                        </v-data-table>
                    </v-tab-item>

                    <!-- Detalles Tab -->
                    <v-tab-item key="detalles">
                        <v-data-table 
                            :headers="headers2" 
                            :items="items2"
                            class="premium-table"
                            mobile-breakpoint="0"
                        >
                            <template v-slot:[`item.total`]="{ item }">
                                <span class="success--text font-weight-black">₡{{ item.total }}</span>
                            </template>
                        </v-data-table>
                    </v-tab-item>
                </v-tabs-items>
            </v-card>
        </v-col>

        <!-- Modal Ver Numeros -->
        <v-dialog transition="dialog-bottom-transition" v-model="dialogReport" max-width="800">
            <div v-if="showNewData">
                <VerNumerosVendidos2 v-bind:allwedOnly="true" v-bind:numerosInfo="numerosInfo" @closed="closed" />
            </div>
        </v-dialog>

      </v-row>
    </v-container>
  </div>
</template>

<script>
import axios from "axios";
import { mapGetters } from "vuex";
import VerNumerosVendidos2 from "./VerNumerosVendidos2.vue";

export default {
  components: {
    VerNumerosVendidos2,
  },
  data() {
    return {
      dialogReport: false,
      showNewData: false,
      valid: false,
      validUsuarios: false,
      validDecargar: false,
      dateModal: false,
      dates: [],
      items: [],
      items2: [],
      usuarios: [],
      modeloReporteVentas: {
        sorteos: [],
        detalles: [],
      },
      numerosInfo: {
        idUsuario: "",
        idSorteo: "",
        fechaInicio: new Date(),
        fechaFin: new Date(),
      },
      tab2: 0,
      dateRules: [
        (v) => v.length == 2 || "Fecha Inicial y Fecha Final Requeridas",
      ],
      headers: [
        // {
        //   text: "Nombre",
        //   align: "start",
        //   value: "nombre",
        // },
        {
          text: "Sorteo",
          align: "start",
          value: "sorteo",
        },
        {
          text: "Total Comisión",
          align: "start",
          value: "comision",
        },
        {
          text: "Total Venta",
          align: "start",
          value: "monto",
        },
        { text: "Números Vendidos", value: "actions", width: 50, sortable: false },
      ],
      headers2: [
        {
          text: "Sorteo",
          align: "start",
          value: "sorteo",
        },
        {
          text: "Usuario",
          align: "start",
          value: "nombre",
        },
        {
          text: "# Tiquete",
          align: "start",
          value: "idTiquete",
        },
        {
          text: "Cliente",
          align: "start",
          value: "cliente",
        },
        {
          text: "Números",
          align: "start",
          value: "numeros",
        },
        {
          text: "Total",
          align: "start",
          value: "total",
        },
      ],
      tiqueteInfo: {
        idTiquete: "",
        tipoTiquete: "",
      },
      reporte: {
        cedula: "",
        fechaInicio: new Date().toLocaleString("en-US", { timeZone: "America/Costa_Rica" }),
        fechaFin: new Date().toLocaleString("en-US", { timeZone: "America/Costa_Rica" }),
      },
    };
  },

  computed: {
    ...mapGetters(["user", "strCia"]),
  },

  created() {
    this.reporte.cedula = this.user.cedula;
    this.getUsuariosPorCia();
  },

  methods: {
    getReport() {
      this.getReporteVentas();
      //this.getRecibidos();
    },

    editItem(item) {
      this.snackValue = false;
      this.editedIndex = this.items.indexOf(item);
      this.editedItem = Object.assign({}, item);
      this.verNumerosVendidos();
    },

    verNumerosVendidos() {
      // this.numerosInfo.idSorteo = 1;
      // this.numerosInfo.fechaInicio = this.dates[0].toString();
      // this.numerosInfo.fechaFin = this.dates[1].toString();

      this.numerosInfo.idSorteo = this.editedItem.idSorteo;
      this.numerosInfo.fechaInicio = this.editedItem.fecha;
      this.numerosInfo.fechaFin = this.editedItem.fecha;
      this.numerosInfo.idUsuario = this.reporte.cedula;
      //this.numerosInfo.modeloReporteVentas = this.modeloReporteVentas;
      this.dialogReport = true;
      this.showNewData = true;
    },

    getUsuariosPorCia() {
      let me = this;
      axios
        .get(
          "api/Usuarios/getUsuariosPorCia?companyId=" +
          this.strCia,
        )
        .then(function (response) {
          me.usuarios = response.data;
          console.log(me.user.cedula);
          const myUser = me.usuarios.find(user => user.cedula === me.user.cedula);
          console.log(myUser.tipo);
          if (myUser.tipo === true) {
            me.reporte.cedula = "0";
            me.validUsuarios = true;
          } else {
            me.reporte.cedula = myUser.cedula;
          }
        })
        .catch(function (error) {
          console.log(error);
        });
    },

    getReporteVentas() {
      let me = this;
      axios
        .get(
          "api/Tiempos/GetReporteVentas?idUsuario=" +
          this.reporte.cedula +
          "&fechaInicio=" +
          this.dates[0].toString() +
          "&fechaFin=" +
          this.dates[1].toString() +
          "&companyId=" +
          this.strCia,
        )
        .then(function (response) {
          me.modeloReporteVentas = response.data;
          me.items = me.modeloReporteVentas.sorteos;
          me.items2 = me.modeloReporteVentas.detalles;
        })
        .catch(function (error) {
          console.log(error);
        });
    },

    getRecibidos() {
      let me = this;
      axios
        .get(
          "api/Reportes/getFacturasRecibidas?cia=" +
          this.strCia +
          "&fechaInicio=" +
          this.dates[0].toString() +
          "&fechaFin=" +
          this.dates[1].toString()
        )
        .then(function (response) {
          me.items2 = response.data;
          me.validDecargar = true;
        })
        .catch(function (error) {
          console.log(error);
        });
    },

    closed() {
      this.customerModal = false;
      this.showNewData = false;
      this.dialogReport = false;
    },
  },
};
</script>

<style scoped>
.reporte-container {
    padding-bottom: 60px;
}

/* Glassmorphism Styles */
.glass-card {
    background: rgba(255, 255, 255, 0.7) !important;
    backdrop-filter: blur(12px) !important;
    border: 1px solid rgba(255, 255, 255, 0.3) !important;
}

.theme--dark .glass-card {
    background: rgba(30, 30, 46, 0.8) !important;
    border: 1px solid rgba(255, 255, 255, 0.1) !important;
}

.glass-btn {
    background: rgba(25, 118, 210, 0.1) !important;
}

/* Table Styling */
.premium-table {
    background: transparent !important;
}

.premium-table >>> th {
    background: rgba(0, 0, 0, 0.03) !important;
    font-weight: 800 !important;
    text-transform: uppercase;
    letter-spacing: 0.5px;
    font-size: 0.7rem !important;
}

.theme--dark .premium-table >>> th {
    background: rgba(255, 255, 255, 0.05) !important;
}

.premium-table >>> tr:hover {
    background: rgba(25, 118, 210, 0.05) !important;
}

/* Animations */
.animate-fade-in {
    animation: fadeIn 0.4s ease-out;
}

@keyframes fadeIn {
    from { opacity: 0; transform: translateY(10px); }
    to { opacity: 1; transform: translateY(0); }
}

.border-bottom {
    border-bottom: 1px solid rgba(0,0,0,0.05);
}

.theme--dark .border-bottom {
    border-bottom: 1px solid rgba(255,255,255,0.05);
}
</style>